module.exports = __webpack_public_path__ + "static/media/cozycafe_vertical.65b13d43.png";